var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotationMarkRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 50,
    viewBox: "0 0 67 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_451)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2225 45.5245C49.8548 42.5536 56.7747 36.3442 58.4955 25.5382C58.9639 22.5989 58.3096 24.8188 56.3297 26.3102C49.8653 31.181 37.1549 29.4564 35.3909 18.3329C31.842 -1.36228 56.3009 -4.77194 63.5401 6.10525C65.2243 8.63351 66.3392 11.5847 66.7409 14.8257C68.4853 28.9215 61.3102 41.4759 48.7059 47.3729C46.374 48.4638 43.9164 49.3175 41.2718 49.9447C39.9475 50.2134 38.9856 49.4888 38.542 48.2609C38.1665 47.2135 38.0382 46.0581 39.2225 45.5245ZM4.18097 45.5245C14.8133 42.5536 21.7344 36.3442 23.4539 25.5382C23.9224 22.5989 23.2681 24.8188 21.2882 26.3102C14.8238 31.181 2.11339 29.4564 0.350715 18.3329C-3.20081 -1.36228 21.2594 -4.77194 28.4986 6.10525C30.1827 8.63351 31.2976 11.5847 31.6994 14.8257C33.4437 28.9215 26.2687 41.4759 13.6643 47.3729C11.3324 48.4638 8.8762 49.3175 6.23023 49.9447C4.90593 50.2134 3.94411 49.4888 3.5005 48.2609C3.12493 47.2135 2.99669 46.0581 4.18097 45.5245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMarkRightIcon);
export default __webpack_public_path__ + "static/media/quotation-mark-right-icon.353b759e6ef4c1822059e9974c889d2d.svg";
export { ForwardRef as ReactComponent };